import Vue from 'vue'
import vuex from 'vuex'
import apis from '../../apis/index'
import cloudApi from '../../apis/cloudStorageApi'
import { routerSplitCharacter } from '@/utils/Constant'

Vue.use(vuex)

export default new vuex.Store({
  state: {
    fileId: 'rootpath',
    fileComplete: false,
    fileList: {
      success: [],
      error: [],
      wait: []
    },
    progress: 0,
    isIphoneX: false
  },
  mutations: {
    changeId (state, nweVal) {
      state.fileId = nweVal
    },
    changeComplete (state) {
      state.fileComplete = !state.fileComplete
    },
    fileListPush (state, obj) {
      let type = obj.type
      let file = obj.file
      file.progress = 0
      type === 0 && state.fileList.wait.unshift(file)
      type === 1 && state.fileList.success.unshift(file)
      type === 2 && state.fileList.error.unshift(file)
    },
    fileListRemove (state, obj) {
      let type = obj.type
      let file = obj.file
      let list
      type === 0 && (list = state.fileList.wait)
      type === 1 && (list = state.fileList.success)
      type === 2 && (list = state.fileList.error)
      list.forEach((i, key) => {
        i.id === file.id && list.remove(key)
      })
    },
    // 上传中状态变更
    uploading (state, data) {
      let newFile = null
      let newIndex = -1
      state.fileList.wait.some((file, index) => {
        if (file.id === data.id) {
          newIndex = index
          newFile = Object.assign(file, data)
          return true
        }
        return false
      })
      if (newIndex !== -1) {
        Vue.set(state.fileList.wait, newIndex, newFile)
      }
    },
    // 设置current是否为iphoneX
    setSystemStatus (state, isIphoneX) {
      state.isIphoneX = isIphoneX
    },
    // 获取当前用户权限按钮信息列表
    SET_PERMISSION_BTN (state, payload) {
      window.localStorage.setItem('permissionBtns', payload.join(routerSplitCharacter))
    }
  },
  actions: {
    getPermissionBtns ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        apis.request(cloudApi.getPermissionBtn).then(res => {
          let array = []
          res.data.forEach(item => {
            array.push(item.code)
          })
          commit('SET_PERMISSION_BTN', array)
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/store/index.js